const BASE_URL = process.env.REACT_APP_UI_BASE_URL;

export const generateShareMessage = (job) => {
  const jobDetailsUrl = `${BASE_URL}jobs/${job.id}`;
  
  const messageParts = [
    `🚀 ${job.companyName} Hiring ${job.title} 🚀\n`,
    `🎓 Role: ${job.title}`,
    `📍 Location: ${job.locations.join(", ")}`,
    job.ctc ? `💰 CTC: ₹${job.ctc}` : null,
    `🎓 Eligibility/Experience: ${job.experience.join(", ")}`,
    `🛠️ Required Skills: ${job.primarySkills.join(", ")}`,
    job.secondarySkills?.length
      ? `🌟 Good to Have: ${job.secondarySkills.join(", ")}\n`
      : `\n`,
    `📷 Apply Link – ${jobDetailsUrl}`,
    `🔎 Explore similar Jobs – ${BASE_URL}jobs`,
    `🔎 Explore premium Courses – ${BASE_URL}courses`,
    `💬 Tag your batchmates, share this post, and help someone land their first tech job! Let’s build the future together.`,
    `👉 Follow this WhatsApp channel for more job updates & career tips: https://lnkd.in/gaj6VeV3`,
  ];

  if (job.hashtags?.length) {
    messageParts.push(`\n${job.hashtags.join(" ")}`);
  }

  return messageParts.filter(Boolean).join("\n");
};
